import { ErrorCodeDisplayData } from "../../loader/errorCodes/ErrorCodesHandler";
import { Delay } from "../../util/time/Delay";
import { AppEvent } from "../Constants";
import { CommonLang } from "../view/lang/CommonLang";
import { AbstractController } from "./AbstractController";
import { CommonGameEvent } from "./event/CommonGameEvent";
export class FreeRoundsGameManager extends AbstractController {
    constructor(factory, model, wrapper) {
        super();
        this.factory = factory;
        this.model = model;
        this.wrapper = wrapper;
    }
    handleWrapperAction(action, data) {
        console.log("> Instance of FR wrapper action");
        if (action.isFreeRoundsNewGameRequest()) {
            //this is sent when free rounds is completed and the user wants to play a new game
            this.dispatchGame(CommonGameEvent.FREE_ROUNDS_OUT);
            this.dispatchGame(CommonGameEvent.FREE_ROUNDS_NEW_GAME_REQUEST);
            //this is a remnane of the old code
        }
        else if (action.isFreeRoundsIn()) {
            //this is sent when opting in to a new free round
            const frData = this.model.getFreeRoundsData();
            frData.setUUID(data.uuid);
            frData.setName(data.name);
            frData.setDescription(data.description);
            frData.setID(data.id);
            frData.setRounds(data.rounds);
            frData.setRoundsRemaining(data.roundsRemaining);
            frData.setSiteID(data.siteID);
            frData.setStake(data.stake);
            frData.setExpiryDate(data.expiryDate);
            frData.setFreeRoundsEnabled(true);
            frData.setCampaignAccumulatedWins(data.campaignAccumulatedWins);
            this.dispatchGame(CommonGameEvent.FREE_ROUNDS_IN);
        }
        else if (action.isFreeRoundsExtraSpins()) {
            this.dispatchGame(CommonGameEvent.FREE_ROUNDS_EXTRA_SPINS);
        }
        else if (action.isFreeRoundsAvailable()) {
            this.model.setFreeRoundsAvailable(true);
        }
        else if (action.isFreeRoundsUnavailable()) {
            this.model.setFreeRoundsAvailable(false);
        }
        else if (action.isFreeRoundsOut()) {
            this.handleFreeRoundsOut(action);
        }
        else if (action.isShowBonusStartMsg()) {
            let bonusStarted = this.model.getHasBonusGame();
            if (bonusStarted) {
                let displayData = new ErrorCodeDisplayData();
                displayData.title = CommonLang.FR_BONUS_START_TITLE; //these are keys from js-localisation
                displayData.message = CommonLang.FR_BONUS_START_MESSAGE; //these are keys from js-localisation
                let event = AppEvent.DYNAMIC_POPUP;
                event.setPayload(displayData);
                this.dispatchCore(event, 0);
            }
        }
    }
    handleFreeRoundsOut(action = null) {
        this.model.getFreeRoundsData().setFreeRoundsEnabled(false);
        this.dispatchGame(CommonGameEvent.FREE_ROUNDS_OUT);
    }
    dispatchGame(event, delay = 0) {
        if (delay > 0) {
            Delay.create(delay, this.model.dispatch, this.model, event);
        }
        else {
            this.model.dispatch(event);
        }
    }
}
//# sourceMappingURL=FreeRoundsGameManager.js.map